import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useLang } from "@/i18n";

export default function useContent() {
  const { lang } = useLang();
  const [content, setContent] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get(`/content?lang=${lang}`).then((r) => { if (alive) setContent(r.data); }).catch(() => {});
    return () => { alive = false; };
  }, [lang]);
  return content;
}
